<template>
  <div class="container">
    <div class="success" v-if="isShow == true">
      <div class="image">
        <img src="../../../assets/images/success.png" alt />
      </div>
      <p class="successText">申请成功</p>
      <p class="waiting">平台审核中，请耐心等待...</p>
    </div>

    <div class="fail" v-if="isShow !== true">
      <div class="image">
        <img src="../../../assets/images/fail.png" alt />
      </div>
      <p class="failText">申请失败</p>
      <p class="waiting">请稍后重试...</p>
    </div>
  </div>
</template>
<script>
import { CellGroup, Form, Field, Toast, Overlay, Icon } from "vant";
// import { mapGetters,mapActions } from "vuex";
// import serviceRefresh from "../../api/redirect/index";
export default {
  components: {
    [CellGroup.name]: CellGroup,
    [Form.name]: Form,
    [Field.name]: Field,
    [Toast.name]: Toast,
    [Overlay.name]: Overlay,
    [Icon.name]: Icon,
  },
  data() {
    return {
      isShow: true,
    };
  },
  //  computed: {
  //   ...mapGetters(["userInfo"])
  // },
  mounted() {
    localStorage.removeItem("userMes");
    this.isShow = this.$route.query.status;
    this.init();
    // this.$route.query.status
  },
  methods: {
    // ...mapActions(["login", "wxLogin"]),
    init() {
      const toast = Toast.loading({
        duration: 0,
        forbidClick: true,
        message: "正在前往购物页",
      });
      let second = 3;
      const timer = setInterval(() => {
        second--;
        if (second > 0) {
          toast.message = "正在前往购物页";
          // // this.Refresh()
        } else {
          clearInterval(timer);
          Toast.clear();
          this.$router.replace("page");
          // this.Refresh()
        }
      }, 700);
    },
    //刷新重新获取登录信息
    // Refresh() {
    //   serviceRefresh
    //     .wxLoginTest(this.userInfo.openId)
    //     .then((res) => {
    //       // Toast.success("绑定成功");
    //       this.wxLogin(res.data).then(() => {
    //         // this.$router.replace("page");
    //       });
    //     })
    //     .catch((err) => {
    //       console.log(err);
    //     });
    // }
  },
};
</script>
<style lang="less">
.container {
  // height: 100%;
  .van-group {
    background-image: url(../../../assets/images/dialogSuccess.png);
    background-repeat: no-repeat;
    width: 100%;
    height: 353.5px;
    background-size: 100% 100%;
    margin-top: 22%;
  }
  .overlayContent {
    position: absolute;
    top: 50%;
    left: 50%;
    width: 220px;
    margin-left: -110px;
    text-align: center;
    display: flex;
    flex-direction: column;
    margin-top: 3vw;
  }
  .overlayCode {
    color: #ee0a24;
    font-size: 22px;
  }
  .button {
    height: 8vw;
    width: 18vw;
    margin: 6vw auto 3vw;
    font-size: 3.73333vw;
    background: #ee0a24;
  }
  .close {
    position: absolute;
    top: 40px;
    right: 30px;
    font-size: 20px;
    color: #919191;
  }
  .success {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 30vw;
  }
  .fail {
    // height: 100%;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    margin-top: 30vw;
  }
  .image {
    width: 66px;
    height: 76px;
  }
  .successText {
    color: #ee0a24;
    font-size: 20px;
    letter-spacing: 3px;
    font-weight: bold;
  }
  .failText {
    color: #ccc;
    font-size: 20px;
    letter-spacing: 3px;
    font-weight: bold;
  }
  .waiting {
    color: #333333;
  }
}
</style>
